import { fondOfKidsStore } from '@/config'
import type { Place, Store } from '@/types'

interface CreateMarkersProps {
  stores: { features: Store[] } | undefined
  url: string
  map: google.maps.Map | undefined
  infoWindow: google.maps.InfoWindow
  navigateTo: (place: Place) => void
}

export const createMarkers = ({
  stores,
  url,
  map,
  infoWindow,
  navigateTo,
}: CreateMarkersProps) => {
  if (!stores) return

  const places = stores.features

  const hasKidsStore = stores.features.some((store) =>
    store.properties.name.toLowerCase().includes('fond of kids store'),
  )

  if (!hasKidsStore) {
    places.push(fondOfKidsStore)
  }

  return places.map((store) => {
    const label = store.properties.name
    const marker = new google.maps.Marker({
      position: store.geometry.coordinates,
      icon: {
        scaledSize: new google.maps.Size(25, 39),
        url,
      },
      map,
      visible: false,
      // @ts-ignore
      assortment: store.properties.assortment,
    })

    marker.addListener('click', () => {
      infoWindow.setContent(label)
      infoWindow.open(map, marker)
      navigateTo(store)
    })
    return marker
  })
}
